export default {
  setDefaultStageData (state: any, payload: any) {
    state.defaultStageData = payload
  },
  setChangeId (state: any, val: number) {
    state.changeStageId = val
  }
}
